import React, { useState } from "react";
import axios from "axios";
import { Toast } from "primereact/toast";
import PaymentStatus from "./PaymentStatus";

interface TranzPayPageProps {
  paymentLink: string;
  onPaymentComplete: () => void;
  receiptId: string;
  onPrevious?: () => void;
}

export default function TranzPayPage({ paymentLink, onPaymentComplete, receiptId, onPrevious }: TranzPayPageProps) {
  const [showStatus, setShowStatus] = useState(false);
  const [receiptData, setReceiptData] = useState<any>(null);
  const toast = React.useRef<Toast>(null);

  const handlePaymentComplete = () => {
    axios
      .get(`${process.env.REACT_APP_ACE_API_Url}/api/ace/receipts?receiptDatabaseId=eq ${receiptId}&ncToken=${localStorage.getItem("NCToken")}`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        },
      })
      .then((response: any) => {
        if (response.data.value && response.data.value.length > 0) {
          setReceiptData(response.data.value[0]);
          setShowStatus(true);
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: "Receipt not found.",
            life: 3000,
          });
        }
      })
      .catch((error: any) => {
        console.error("Error fetching receipt:", error);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Error checking payment status.",
          life: 3000,
        });
      });
  };

  if (showStatus && receiptData) {
    return <PaymentStatus receiptData={receiptData} onContinue={onPaymentComplete} onPrevious={() => setShowStatus(false)} />;
  }

  return (
    <>
      <Toast ref={toast} />
      <div className="page-container">
        <div className="page-header mb-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold">Complete Payment</h1>
              <p className="text-sm text-gray-500">
                Click "View Payment Page" to open the secure payment portal, then click "Payment Complete" to continue.
              </p>
            </div>
          </div>
        </div>
        <div className="form-grid">
          <div className="flex flex-col items-center justify-center p-8 w-full">
            <p className="text-sm text-gray-600 mb-6">Click the button below to open the secure payment page in a new tab.</p>
            <button
              className="btn btn-primary mb-6"
              onClick={() => window.open(paymentLink, "_blank")}
            >
              View Payment Page
            </button>
          </div>
          <div className="form-actions flex justify-center mt-8">
            <button className="btn btn-primary" onClick={handlePaymentComplete}>
              Payment Complete - Continue
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
